import { create } from 'zustand';

type FeatureFlagState = {
  flagEnabledCustomSettingsFlow: boolean | undefined;
  setFlagEnabledCustomSettingsFlow: (value: boolean | undefined) => void;
};

export const useFeatureFlagStore = create<FeatureFlagState>(set => ({
  flagEnabledCustomSettingsFlow: undefined,
  setFlagEnabledCustomSettingsFlow: value => set({ flagEnabledCustomSettingsFlow: value }),
}));
